import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, Text, HStack, Grid, GridItem, VStack, Spacer, Divider, Link, useToast
} from '@chakra-ui/react';
import { groupBy, sortBy } from 'lodash';
import { withNamespaces } from 'react-i18next';
// import i18n from "../../i18n";

import { setNavTab } from '../../redux/actions';
import { getCurrentNavTab, getDepartmentList } from '../../redux/selectors';
import { apiLoadListDepartment } from '../../redux/apis/DepartmentApis';
import { ACTIVE_DEPARTMENT_TAB } from "../../redux/constants";
import { FLOOR_LIST, FLOOR_LIST_EN, PATIENT_INFORMATION_MAX_AGE } from "../../constants";
import { displayConfirmAlert } from "../utils"

import Header from '../Home/Header';
import Navbar from '../Home/Navbar';
import NoDataPage from '../../components/NoData';
import NoEventPage from '../../components/NoEvent';

function Department(props) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["selectedClinic", "makeDoctorAppointmentDatas", "loginCookie"]);
    const navigate = useNavigate();
    const mounted = useRef();
    const toast = useToast();
    const toastId = "department-toast";
    const val = useRef();
    
    useEffect(() => {
        if(!mounted.current) {
            if(!cookies.selectedClinic?.data?.id) {
                displayConfirmAlert("Bạn vui lòng chọn phòng khám trước khi tiếp tục!", () => {
                    navigate("/");
                });
            } else {
                props.apiLoadListDepartment({ company_id: cookies.selectedClinic?.data?.id });
                props.setNavTab(ACTIVE_DEPARTMENT_TAB);
            }

            //if(cookies.makeDoctorAppointmentDatas?.data && !cookies.makeDoctorAppointmentDatas?.data?.selectedDepartment) {
            if(cookies.makeDoctorAppointmentDatas?.data?.patientDetail && !cookies.makeDoctorAppointmentDatas?.data?.departmentDetail) {
                if(!toast.isActive(toastId)) {
                    toast({
                        id: toastId,
                        title: "Bước tiếp theo",
                        description: "Chọn phòng khám",
                        status: "warning",
                        duration: 5000,
                        isClosable: true,
                        position: "bottom-right"
                    })
                }
            }

            mounted.current = true;
        }

        val.current = props
    }, [props]);

    useEffect(() => {
        return () => {
            if(props.currentNavTab !== val.current.currentNavTab) {
                toast.closeAll()
            }
        }
    }, [])

    const handleConfirm = (data) => {
        if(!cookies.makeDoctorAppointmentDatas?.data?.patientDetail) {
            displayConfirmAlert("Bạn chưa điền thông tin đăng ký khám!", () => navigate("/"));
            return;
        }

        // update cookie
        setCookie("makeDoctorAppointmentDatas", 
            { 
                data: {
                    ...cookies.makeDoctorAppointmentDatas?.data,
                    departmentDetail: data
                } 
            }, 
            { 
                path: '/', maxAge: PATIENT_INFORMATION_MAX_AGE 
            }
        );

        navigate("/doctor");
    }

    let departmentListGroup = groupBy(props.departmentList, "location");

    
    if(!(cookies.selectedClinic?.data?.id)) {
        return (
            <Flex flexDirection="column">
                <Header />
                <Navbar />
                <NoEventPage text="Bạn vui lòng chọn phòng khám trước khi tiếp tục!"/>
            </Flex>
        )
    }

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                {
                    (Object.keys(departmentListGroup).length > 0) &&
                    <React.Fragment>
                            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} flexWrap="wrap" 
                                justifyContent="center" borderRadius={8} bg="#ffffff" px={4} py={2}
                            >
                                {
                                    Object.keys(departmentListGroup).map(key => {
                                        let sortDLG = sortBy(departmentListGroup[key], ['id']);

                                        return (
                                            <Flex key={key} flexDirection={{ base: "column", md: "column", lg: "column" }}
                                                width={{ base: "100%", md: "100%", lg: "30%" }} mx="10px" px={8}
                                            >
                                                <Text fontSize={{ base: "24px", md: "24px", lg: "36px" }} fontWeight="700" textAlign="center" color="gray.600">
                                                    { props.i18n.language === "en" ? FLOOR_LIST_EN[key] : FLOOR_LIST[key]}
                                                </Text>
                                                {
                                                    sortDLG.map(doc => {
                                                        return (
                                                            <React.Fragment key={doc.id}>
                                                                <HStack spacing={0} height="60px" my="10px" _hover={{ cursor: 'pointer' }} borderRadius={8} borderWidth="2px" 
                                                                    borderColor={ cookies.makeDoctorAppointmentDatas?.data?.departmentDetail?.id === doc.id ? "green.500" : "black.700" } 
                                                                    onClick={() => handleConfirm(doc)}
                                                                >
                                                                    <Box bg="#E2E9E6" color="gray.700" height="100%" width="30%" textAlign="center" alignContent="center" borderRadius={4} px={2}>
                                                                        <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="700">
                                                                            {doc.name}
                                                                        </Text>
                                                                    </Box>
                                                                    <HStack color="#FFFFFF" height="100%" width="70%" justify="center" bg="gray.700"
                                                                        borderWidth="2px" borderRadius={4} _hover={{ bg: "green.600" }} px={2}
                                                                    >
                                                                        <Text fontSize={{ base: "15px", md: "18px", lg: "18px" }} fontWeight="700">
                                                                            {doc.specialist && doc.specialist.toUpperCase()}
                                                                        </Text>
                                                                    </HStack>
                                                                </HStack>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </Flex>
                                        )
                                    })
                                }
                            </Flex>
                        {/* </Box> */}
                    </React.Fragment>
                }
                                
                {
                    ((Object.keys(departmentListGroup).length) === 0) &&
                    <VStack width="100%" justify="flex-start" align="center" mt={20} px={4} spacing={2}>
                        <NoDataPage text="Hiện tại chưa có dữ liệu về Phòng khám."/>
                        {
                            (cookies?.loginCookie && cookies?.loginCookie?.data?.company_id === cookies?.selectedClinic?.data?.id) &&
                                <Text fontSize={{ base: "16px", md: "18px", lg: "18px" }} fontWeight="700">
                                    Bạn có thể tạo dữ liệu Phòng khám từ
                                    <Link color="teal.500" href='/settings' fontWeight="700" target="_blank" ml={1}>Danh mục Phòng khám</Link>
                                </Text>
                                
                        }
                    </VStack>
                }
            </Box>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const currentNavTab =           getCurrentNavTab(state);
    const departmentList =          getDepartmentList(state);
    
    return { currentNavTab, departmentList };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListDepartment:  payload => dispatch(apiLoadListDepartment(payload)),

    setNavTab:              payload => dispatch(setNavTab(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Department));